// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3gykN","header":"MergedInvoice_header__2-FOI"};